import { render, staticRenderFns } from "./ExtendedTables.vue?vue&type=template&id=5b2b848f&scoped=true&"
import script from "./ExtendedTables.vue?vue&type=script&lang=js&"
export * from "./ExtendedTables.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedTables.vue?vue&type=style&index=0&id=5b2b848f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b848f",
  null
  
)

export default component.exports